interface SubnetInfo {
  description: string;
  website?: string;
  github?: string;
  x?: string;
}

export const subnetDescriptions: Record<number, SubnetInfo> = {
  0: {
    description: "Root network of the Bittensor blockchain, responsible for consensus and governance.",
    website: "",
    github: "",
    x: ""
  },
  1: {
    description: "Apex uses tasks to manage miner behavior by having a Validator create a variety of tasks, including a challenge for miners to solve, distribute them to 100 miners, and score all the completions they submit.",
    website: "https://www.macrocosmos.ai/",
    github: "https://github.com/macrocosm-os/prompting",
    x: "https://x.com/MacrocosmosAI"
  },
  2: {
    description: "Omron is building a Proof-of-Inference system to create the world's largest peer-to-peer Verified Intelligence network on the Bittensor platform.",
    website: "https://omron.ai/",
    github: "https://github.com/inference-labs-inc/omron-subnet?tab=readme-ov-file",
    x: "https://x.com/omron_ai"
  },
  3: {
    description: "Decentralized training framework that enables large-scale model training across heterogeneous compute resources by connecting diverse computational nodes through an incentive mechanism to ensure honest participation and quality contributions.",
    website: "https://www.tplr.ai/",
    github: "https://github.com/tplr-ai/templar",
    x: "https://x.com/tplr_ai"
  },
  4: {
    description: "Targon is a deterministic verification mechanism designed to incentivize miners to run endpoints that comply with OpenAI standards and handle both synthetic and organic queries.",
    website: "https://www.manifold.inc/",
    github: "https://github.com/manifold-inc/targon",
    x: "https://x.com/manifoldlabs"
  },
  5: {
    description: "Subnet 5 aims to train and serve cutting-edge, generalizable text-embedding models by leveraging miners to handle large-scale training on extensive textual data, validators to rigorously evaluate these models against state-of-the-art benchmarks, and publicly providing them through the Bittensor Subnet 5 validator API for broad adoption and integration.",
    website: "https://www.kaito.ai/",
    github: "https://github.com/OpenKaito/openkaito?tab=readme-ov-file",
    x: "" 
  },
  6: {
    description: "SN6 incentivizes the prediction of future binary events—sourced from platforms like Polymarket and continually expanded via various data providers—that are processed by an LLM pipeline focusing on judgmental rather than statistical forecasting, with miners expected to use LLM-based models.",
    website: "https://www.infinitegam.es/",
    github: "https://github.com/amedeo-gigaver/infinite_games",
    x: "https://x.com/Playinfgames"
  },
  7: {
    description: "SubVortex is an incentivized, decentralized network of subtensor nodes within the Bittensor ecosystem, outlining its structure, objectives, and mechanisms to foster decentralization, stability, and efficient resource allocation.",
    website: "https://www.infinitegam.es/",
    github: "https://github.com/eclipsevortex/SubVortex",
    x: "https://x.com/SubVortexTao"
  },
  8: {
    description: "PTN aggregates quant and deep learning trading signals to deliver the most comprehensive trading insights across various asset classes.",
    website: "https://www.taoshi.io/",
    github: "https://github.com/taoshidev/proprietary-trading-network",
    x: "https://x.com/taoshiio"
  },
  9: {
    description: "Pretraining subnet dedicated to foundational model development.",
    website: "https://www.macrocosmos.ai/",
    github: "https://github.com/macrocosm-os/pretraining",
    x: "https://x.com/MacrocosmosAI"
  },
  10: {
    description: "Decentralized yield optimizers. Miners develop algorithms to maximize returns across fixed pools, and validators assess performance based on yield generation.",
    website: "https://sturdy.finance/",
    github: "https://github.com/Sturdy-Subnet/sturdy-subnet/",
    x: "https://x.com/SturdyFinance"
  },
  11: {
    description: "The Dippy Roleplay subnet on Bittensor harnesses open-source collaboration to develop the world's leading roleplay LLM.",
    website: "https://www.dippy.ai/",
    github: "https://github.com/impel-intelligence/dippy-bittensor-subnet",
    x: "https://x.com/dippy_ai"
  },
  12: {
    description: "ComputeHorde is a Bittensor subnet that transforms untrusted miner GPUs into scalable, trusted compute resources, enabling cost-effective, decentralized GPU power for validators and supporting Bittensor's expansion to over 1,000 subnets.",
    website: "https://computehorde.io/",
    github: "hhttps://github.com/backend-developers-ltd/ComputeHorde",
    x: "https://x.com/ComputeHorde"
  },
  13: {
    description: "Data Universe is a decentralized, scalable Bittensor subnet that enables data collection and storage across 200 miners, supporting up to 50 petabytes of data while allowing efficient querying via Validators with minimal storage requirements.",
    website: "https://www.macrocosmos.ai/",
    github: "https://github.com/macrocosm-os/data-universe/",
    x: "https://x.com/MacrocosmosAI"
  },
  14: {
    description: "TAOHash enables decentralized Proof-of-Work mining hashrate rental and exchange, where validators earn weights for providing hashrate, and miners speculate on hashrate, hashprice, and Alpha emissions.",
    website: "https://taohash.ai/",
    github: "https://github.com/latent-to/taohash",
    x: "https://x.com/taohash"
  },
  15: {
    description: "De_val is a decentralized Bittensor subnet for evaluating LLMs in RAG-based scenarios, leveraging competitive, community-driven validation to enhance accuracy, relevancy, and summary completeness while enabling miners to fine-tune models and optimize processing pipelines.",
    website: "https://www.de-val.ai/",
    github: "https://github.com/deval-core/De-Val",
    x: "https://x.com/de_valAI"
  },
  16: {
    description: "HashTensor (SN16) transforms mining power from high-value PoW blockchains like Kaspa into on-chain value within the Bittensor ecosystem, redirecting rewards into $TAO and $ALPHA via a buy-and-burn mechanism to enhance long-term value.",
    website: "",
    github: "",
    x: "https://x.com/HashTensor"
  },
  17: {
    description: "A decentralized platform for democratizing 3D content creation, enabling anyone to generate virtual worlds, games, and immersive experiences using advanced generative models, with AI-driven assets, voice, and sound generated in real time.",
    website: "",
    github: "https://github.com/404-Repo/three-gen-subnet",
    x: "https://x.com/404gen_"
  },
  18: {
    description: "Decentralized AI platform that provides reliable text and image responses via API, fostering fair and transparent intelligence production through incentivized mining and prompt fulfillment.",
    website: "https://www.zeussubnet.com/",
    github: "https://github.com/Orpheus-AI/Zeus",
    x: "https://x.com/zeussubnet"
  },
  19: {
    description: "Nineteen is a decentralized AI inference network providing access to top open-source LLMs, image generation models, embedding models, and custom workflows like avatar generation.",
    website: "https://app.sn19.ai/",
    github: "https://github.com/rayonlabs/nineteen",
    x: "https://x.com/rayon_labs"
  },
  20: {
    description: "BitAgent streamlines task management and automation by integrating large language models with web browsers, Discord, and custom apps, enabling seamless intelligent assistance across platforms.",
    website: "https://gogoagent.ai/",
    github: "https://github.com/RogueTensor/bitagent_subnet",
    x: "https://x.com/FrankRizz07"
  },
  21: {
    description: "OMEGA Any-to-Any is a decentralized, open-source AI initiative focused on developing state-of-the-art multimodal models by incentivizing top researchers to contribute compute and insights.",
    website: "https://focus.omega.inc/",
    github: "https://github.com/omegalabsinc/omegalabs-anytoany-bittensor",
    x: "https://x.com/omegalabsai"
  },
  22: {
    description: "Desearch is an AI-powered, unbiased search engine that enables developers to integrate verifiable search capabilities with metadata from platforms like X, Reddit, Arxiv, and the web.",
    website: "https://console.datura.ai/",
    github: "https://github.com/Datura-ai/desearch",
    x: "https://x.com/desearch_ai"
  },
  23: {
    description: "Zuvu is building a decentralized economy for AI, where models, agents, and data are monetized and transformed into liquid, tradable assets.",
    website: "https://www.zuvu.ai/",
    github: "https://github.com/SocialTensor/SocialTensorSubnet",
    x: "https://x.com/NuanceSubnet"
  },
  24: {
    description: "OMEGA Labs is building the world's largest decentralized multimodal dataset to accelerate AGI research, democratizing access to diverse human knowledge for researchers and developers.",
    website: "https://focus.omega.inc/",
    github: "https://github.com/omegalabsinc/omegalabs-bittensor-subnet",
    x: "https://x.com/omegalabsai"
  },
  25: {
    description: "Protein Folding subnet for biological structure prediction.",
    website: "https://www.macrocosmos.ai/",
    github: "https://github.com/macrocosm-os/folding",
    x: "https://x.com/MacrocosmosAI"
  },
  26: {
    description: "Storb is a decentralized, fault-tolerant, and efficient object storage network designed for secure and distributed digital storage.",
    website: "https://storb.dev/",
    github: "https://github.com/fr34kcoders/storb",
    x: "https://x.com/storbdevs"
  },
  27: {
    description: "NI Compute facilitates a decentralized compute market where miners provide GPU resources for rewards, while validators assess performance and allocate resources efficiently in a trustless, permissionless system.",
    website: "https://neuralinternet.ai/",
    github: "https://github.com/neuralinternet/ni-compute",
    x: "https://x.com/neural_internet"
  },
  28: {
    description: "Meme subnet rewarding emissions to miners based on alpha token holdings.",
    website: "",
    github: "",
    x: ""
  },
  29: {
    description: "Coldint maximizes collective training efforts by incentivizing the sharing of models, knowledge, and code, fostering transparency, collaboration, and continuous high-quality improvements in decentralized AI development.",
    website: "https://coldint.io/",
    github: "https://github.com/coldint",
    x: "https://x.com/Coldint_"
  },
  30: {
    description: "Bettensor is a sports prediction network that enables fans to forecast event outcomes while providing ML/AI researchers a platform to develop and benchmark models against human intuition.",
    website: "https://bettensor.com/",
    github: "https://github.com/Nickel5-Inc/bettensor",
    x: "https://x.com/Bettensor"
  },
  31: {
    description: "Neural Architecture Search (NAS) is a machine learning field that automates the design of artificial neural network architectures.",
    website: "",
    github: "https://github.com/neuronlogic/NASChain?tab=readme-ov-file",
    x: "https://x.com/NullUntilBoot"
  },
  32: {
    description: "It's AI is an AI detection tool that identifies whether text is human-written or AI-generated, offering deep scan functionality to analyze AI probabilities for each sentence.",
    website: "https://its-ai.org/",
    github: "https://github.com/It-s-AI/llm-detection",
    x: "https://x.com/ai_detection"
  },
  33: {
    description: "ReadyAI is an open-source initiative that provides a low-cost, resource-efficient pipeline for structuring and semantically tagging raw data for vector databases and AI applications.",
    website: "https://readyai.ai/",
    github: "https://github.com/afterpartyai/bittensor-conversation-genome-project",
    x: "https://x.com/ReadyAI_"
  },
  34: {
    description: "BitMind subnet exploring cognitive computing architectures.",
    website: "https://www.bitmindlabs.ai/",
    github: "https://github.com/BitMind-AI/bitmind-subnet",
    x: "https://x.com/BitMindAI"
  },
  35: {
    description: "LogicNet is a decentralized AI network dedicated to developing an open-source, high-performance model for solving complex mathematical problems and data analysis, using incentivized feedback loops to enhance quality continuously.",
    website: "https://logicnet.ai/",
    github: "https://github.com/LogicNet-Subnet/LogicNet",
    x: "https://x.com/logicnet_ait"
  },
  36: {
    description: "Web Agents Subnet utilizes the Infinite Web Arena (IWA) benchmark to incentivize miners to develop advanced web agents, ensuring continuous adaptation, reasoning, and generalization through dynamic AI-generated challenges.",
    website: "https://autoppia.com/infinite-web-arena-subnet",
    github: "https://github.com/autoppia/autoppia_web_agents_subnet",
    x: "https://x.com/AutoppiaAI"
  },
  37: {
    description: "The Finetuning Subnet 37 rewards miners for fine-tuning Large Language Models (LLMs) through a continuous benchmark using dynamically generated synthetic data from Subnet 18.",
    website: "https://www.macrocosmos.ai/",
    github: "https://github.com/macrocosm-os/finetuning",
    x: "https://x.com/MacrocosmosAI"
  },
  38: {
    description: "A Bittensor subnetwork that rewards miners for contributing compute, bandwidth, and low-latency resources to collaboratively train a single Large Language Model (LLM).",
    website: "",
    github: "https://github.com/KMFODA/DistributedTraining",
    x: ""
  },
  39: {
    description: "The EdgeMaxxing subnet focuses on optimizing AI models for consumer devices, having already enhanced Stable Diffusion XL for the NVIDIA GeForce RTX 4090 and now working on Flux Schnell.",
    website: "https://wombo.com/m/home",
    github: "https://github.com/womboai/edge-maxxing",
    x: "https://x.com/WOMBO"
  },
  40: {
    description: "The Chunking subnet advances Retrieval-Augmented Generation (RAG) by incentivizing the development of intelligent chunking solutions that optimize intrachunk similarity and interchunk dissimilarity.",
    website: "https://chunking.com/",
    github: "https://github.com/VectorChat/chunking_subnet?tab=readme-ov-file",
    x: "https://x.com/vectorchatai"
  },
  41: {
    description: "Sportstensor pioneers innovation in sports prediction by incentivizing miners to develop algorithms that gain an edge over market odds, leveraging the Bittensor network for machine-driven dominance in analytics.",
    website: "https://www.sportstensor.com/",
    github: "https://github.com/sportstensor/sportstensor",
    x: "https://x.com/sportstensor"
  },
  42: {
    description: "Subnet 42 by Masa delivers real-time, structured, and high-quality data for AI agents and application developers.",
    website: "https://www.masa.ai/",
    github: "https://github.com/masa-finance/masa-bittensor",
    x: "https://x.com/getmasafi"
  },
  43: {
    description: "A decentralized network built on Bittensor that focuses on solving graph optimization problems through collaborative AI computation.",
    website: "https://graphite-ai.net/",
    github: "https://github.com/GraphiteAI/Graphite-Subnet",
    x: "https://x.com/GraphiteSubnet"
  },
  44: {
    description: "Score Vision is a decentralized computer vision framework on Bittensor that drastically reduces the cost and time for complex video analysis, starting with Game State Recognition (GSR) in football to revolutionize sports analytics, betting, and data services.",
    website: "https://t.co/0WfRPB3Ldp",
    github: "https://github.com/score-technologies/score-vision",
    x: "https://x.com/webuildscore"
  },
  45: {
    description: "Gen42 is a decentralized software engineering subnet on Bittensor that develops scalable, open-source tools powered by large language models, fostering innovation through competitive benchmarking, product enablement, and ecosystem integration.",
    website: "",
    github: "https://github.com/brokespace/code/",
    x: "https://x.com/FrankRizz07"
  },
  46: {
    description: "NeuralAI is a Bittensor subnet focused on generating high-quality 3D models using advanced neural networks, providing developers and artists with tools for gaming, virtual reality, and simulations.",
    website: "https://goneural.ai/",
    github: "https://github.com/GoNeuralAI/neural-subnet",
    x: "https://x.com/goneuralai"
  },
  47: {
    description: "A decentralized AI solution that accelerates inference by compressing long natural language token sequences into soft-tokens, reducing computational cost and inference time.",
    website: "https://www.condenses.ai/",
    github: "https://github.com/condenses/neural-condense-subnet",
    x: ""
  },
  48: {
    description: "Nextplace AI is a decentralized network that democratizes housing market intelligence by providing open and accessible home price evaluations, challenging monopolies and gatekeepers.",
    website: "https://nextplace.ai/",
    github: "https://github.com/Nickel5-Inc/Nextplace",
    x: "https://x.com/NextPlace_AI"
  },
  49: {
    description: "Polaris is a decentralized platform that connects miners with spare GPU resources to a network for AI tasks and compute-intensive workloads in a trustless environment.",
    website: "https://www.polariscloud.ai/#Home",
    github: "https://github.com/bigideaafrica/polaris",
    x: "https://x.com/polariscloudai"
  },
  50: {
    description: "Synth, a Bittensor subnet by Mode, generates high-quality synthetic data for price forecasting, enabling on-chain agentic economies through decentralized intelligence.",
    website: "https://www.mode.network/synth",
    github: "https://github.com/mode-network/synth-subnet",
    x: "https://x.com/SynthdataCo"
  },
  51: {
    description: "The Compute Subnet on Bittensor powers a decentralized peer-to-peer GPU rental marketplace, connecting miners contributing GPU resources with users needing computational power.",
    website: "https://celiumcompute.ai/",
    github: "https://github.com/Datura-ai/compute-subnet?tab=readme-ov-file",
    x: "https://x.com/celiumcompute"
  },
  52: {
    description: "Tensorplex Dojo Subnet is a decentralized platform on Bittensor that crowdsources high-quality human-generated datasets, allowing users to earn TAO by labeling data and contributing human preference inputs to foster inclusive and ethical AI development.",
    website: "https://www.tensorplex.ai/",
    github: "https://github.com/tensorplex-labs/dojo",
    x: "https://x.com/TensorplexLabs"
  },
  53: {
    description: "Efficient Frontier, a collaboration between SignalPlus and Bittensor, leverages decentralized machine learning and live trading data to develop optimal risk-weighted crypto trading strategies, providing everyday users with professional trading tools for democratized market access.",
    website: "https://t.signalplus.com/mining",
    github: "https://github.com/EfficientFrontier-SignalPlus/EfficientFrontier",
    x: "https://x.com/Effi_Frontier"
  },
  54: {
    description: "Yanez MIIDs aim to create synthetic identities, either fully fabricated or blending real attributes, to test and train anti-fraud models and identity recognition algorithms. These varied identity types cater to diverse use cases, enhancing the robustness of fraud detection and identity verification systems.",
    website: "https://www.yanez.ai/",
    github: "https://github.com/yanez-compliance/MIID-subnet",
    x: "https://x.com/yanez__ai"
  },
  55: {
    description: "Precog is an AI-driven high-frequency Bitcoin price forecasting subnet that leverages Coin Metrics' trusted data, enabling miners to generate financial intelligence for top crypto institutions.",
    website: "",
    github: "https://github.com/coinmetrics/precog",
    x: "https://x.com/coinmetrics"
  },
  56: {
    description: "Gradients enables anyone to train state-of-the-art image and text AI models on Bittensor's decentralized AI blockchain with just a few clicks.",
    website: "https://gradients.io/",
    github: "https://github.com/rayonlabs/G.O.D?tab=readme-ov-file",
    x: "https://x.com/rayon_labs"
  },
  57: {
    description: "Gaia is a platform dedicated to the research and development of geospatial machine learning models, advancing AI-driven insights for spatial data analysis.",
    website: "https://www.gaiaresearch.ai/",
    github: "https://github.com/Nickel5-Inc/Gaia",
    x: "https://x.com/gaia_ai_"
  },
  58: {
    description: "Building the world's most advanced open-source speech model to enable immersive and lifelike AI-driven interactions.",
    website: "https://www.dippyspeech.com/",
    github: "https://github.com/impel-intelligence/dippy-speech-subnet",
    x: "https://x.com/dippy_ai"
  },
  59: {
    description: "The first competitive agent ecosystem where market forces and real engagement shape the evolution of sentient AI agents.",
    website: "https://www.masa.ai/",
    github: "https://github.com/masa-finance/agent-arena-subnet",
    x: "https://x.com/getmasafi"
  },
  60: {
    description: "Bitsec is an AI-powered ecosystem for detecting and fixing code vulnerabilities in subnet codebases and smart contracts, with plans to expand to broader code security applications.",
    website: "https://bitsec.ai/",
    github: "https://github.com/Bitsec-AI/subnet",
    x: "https://x.com/bitsecai"
  },
  61: {
    description: "The RedTeam subnet by Innerworks is a decentralized platform advancing cybersecurity innovation through competitive programming challenges.",
    website: "http://storage.redteam.technology/",
    github: "https://github.com/RedTeamSubnet/RedTeam?tab=readme-ov-file",
    x: "https://x.com/_redteam_"
  },
  62: {
    description: "Ridges is a decentralized marketplace for autonomous software engineering agents, incentivizing them to solve real-world software challenges with increasing complexity and generalization.",
    website: "https://www.ridges.ai/",
    github: "https://github.com/ridgesai/ridges",
    x: "https://x.com/ridges_ai"
  },
  63: {
    description: "Quantum computing on Bittensor",
    website: "",
    github: "",
    x: "https://x.com/qBitTensor"
  },
  64: {
    description: "Serverless AI compute platform that lets you deploy, run, and scale models in seconds, either directly through the platform or via a simple API.",
    website: "https://rayonlabs.ai/",
    github: "https://github.com/rayonlabs/chutes",
    x: "https://x.com/rayon_labs"
  },
  65: {
    description: "TPN is a decentralized subnet that enables secure, private, and geographically diverse internet access through a global network of VPN providers.",
    website: "",
    github: "https://github.com/beyond-stake/tpn-subnet",
    x: "https://x.com/SN65_TPN"
  },
  66: {
    description: "FakeNews is a decentralized AI subnet on Bittensor that provides real-time fake news detection and fact-checking, aiming to surpass traditional solutions and become the world's most trusted source for news verification.",
    website: "",
    github: "https://github.com/gutenberg-team/fakenews-subnet",
    x: ""
  },
  67: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  68: {
    description: "Decentralized, AI-driven platform that continuously optimizes drug discovery through competitive, transparent, and efficient machine learning and heuristic-based agent development.",
    website: "https://www.metanova-labs.com/",
    github: "",
    x: "https://x.com/metanova_labs"
  },
  69: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  70: {
    description: "Vericore focuses on large-scale semantic fact-checking and verification. It analyzes statements and provides evidence-based validation using relevant quotes and source materials that either support or refute the claims.",
    website: "https://www.dfusion.ai/",
    github: "https://github.com/dfusionai/Vericore",
    x: "https://x.com/dFusionAI"
  },
  71: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  72: {
    description: "StreetVision, launched by NATIX, harnesses real-world data and decentralized AI to advance autonomous driving and map-making applications. This trustless ecosystem rewards contributors and continuously refines models for real-time, cost-effective street-level analysis.",
    website: "https://www.natix.network/",
    github: "",
    x: "https://x.com/NATIXNetwork"
  },
  73: {
    description: "MetaHash is a decentralized OTC marketplace for miners to trade their rewards for liquid tokens, enhancing liquidity and value distribution across the network.",
    website: "",
    github: "",
    x: "https://x.com/MetaHashSn73"
  },
  74: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  75: {
    description: "Hippius provides decentralized storage and computing infrastructure with AWS compatibility. It features an advanced coldkey/hotkey system for multi-server management and employs a 60/30/10 revenue split between miners, validators, and treasury.",
    website: "https://hippius.com/",
    github: "",
    x: "https://x.com/hippius_subnet"
  },
  76: {
    description: "Safe Scan Cancer AI Detection leverages AI and blockchain to provide free, open-source cancer detection tools, making advanced algorithms accessible to everyone and supporting early diagnosis for patients and healthcare professionals worldwide.",
    website: "https://safe-scan.ai/",
    github: "https://github.com/safe-scan-ai/cancer-ai",
    x: "https://x.com/SAFESCAN_AI"
  },
  77: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  78: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  79: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  80: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  81: {
    description: "Patrol is a specialized subnet built to transform security in the crypto space. It harnesses the collective intelligence of miners to construct an expansive relational graph that connects both on-chain and off-chain data. Starting with Bittensor, Patrol will enable fast, efficient investigations, risk analysis, and more.",
    website: "https://www.tensora.com/",
    github: "",
    x: "https://x.com/TensoraGroup"
  },
  82: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  83: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  84: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  85: {
    description: "Vidaio is an open-source, decentralized initiative focused on video processing, particularly enhancing video upscaling and compression",
    website: "https://vidaio.io/",
    github: "https://github.com/vidaio-subnet/vidaio-subnet",
    x: "https://x.com/vidaio_"
  },
  86: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  87: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  88: {
    description: "Sταking optimizes staking strategies for the Tao/Alpha ecosystem, with miners sharing strategies, validators scoring them, and results shown on StakingAlpha.com, targeting alpha extraction and optimized returns across crypto and traditional markets.",
    website: "https://stakingalpha.com/",
    github: "https://github.com/mobiusfund/staking",
    x: "https://x.com/StakingAlpha88"
  },
  89: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  90: {
    description: "",
    website: "",
    github: "https://github.com/frkrueger/bittensor-brain-subnet",
    x: ""
  },
  91: {
    description: "TensorProx is a platform that harnesses advanced AI and decentralized network architecture to deliver robust, real-time DDoS detection and defense, ensuring scalable, secure digital ecosystems.",
    website: "https://www.shugo.io/",
    github: "https://github.com/shugo-labs/tensorprox",
    x: "https://x.com/shugoio"
  },
  92: {
    description: "ReinforcedAI delivers rapid, scalable, and continuously evolving AI-driven Solidity audits, enabling developers to identify vulnerabilities in seconds through a decentralized audit network.",
    website: "https://reinforced.app/",
    github: "https://github.com/ReinforcedAIAudits/solidity-audit",
    x: "https://x.com/Reinforced_AI"
  },
  93: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  94: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  95: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  96: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  97: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  98: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  99: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  },
  100: {
    description: "Unknown subnet with undisclosed specialization.",
    website: "",
    github: "",
    x: ""
  }
};